import React from 'react';

interface StarRatingProps {
  rating: number;
}

const StarRating: React.FunctionComponent<StarRatingProps> = ({ rating }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (i <= rating) {
      stars.push(
        <span key={i} className="star filled">
          ★
        </span>,
      );
    } else {
      stars.push(
        <span key={i} className="star">
          ☆
        </span>,
      );
    }
  }

  return <div className="star-rating">{stars}</div>;
};

export default StarRating;
